import { render, staticRenderFns } from "./RouteInfoV2RouteModal.vue?vue&type=template&id=64fdb8e0&scoped=true&"
import script from "./RouteInfoV2RouteModal.vue?vue&type=script&lang=ts&"
export * from "./RouteInfoV2RouteModal.vue?vue&type=script&lang=ts&"
import style0 from "./RouteInfoV2RouteModal.vue?vue&type=style&index=0&id=64fdb8e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fdb8e0",
  null
  
)

export default component.exports